import React from 'react';
import {UsePaginationInstanceProps} from 'react-table';
import {DfbDropdownLeftSymbol, DfbDropdownRightSymbol} from '../symbol/Symbol';

export type PaginationProps = UsePaginationInstanceProps<any> & {
    pageIndex: number,
    ariaLabel: string,
    previousAriaLabel: string,
    nextAriaLabel: string
};

const Pagination = ({
                        canPreviousPage,
                        gotoPage,
                        canNextPage,
                        pageCount,
                        previousPage,
                        nextPage,
                        pageIndex,
                        ariaLabel,
                        previousAriaLabel,
                        nextAriaLabel
                    }: PaginationProps) => {

    const pageNumbers = [];

    if (pageCount < 11 && pageCount > 2) {
        // Add all numbers without first and last
        for (let i = 2; i < pageCount; i++) {
            pageNumbers.push(i);
        }
    } else {
        // Add some pages from the middle
        for (let i = pageIndex - 3; i <= pageIndex + 3; i++) {
            if (i > 0 && i < pageCount - 1) {
                pageNumbers.push(i + 1);
            }
        }
    }

    // Hack to support correct styling by CSS rule ".dfb-Button[aria-disabled]" for disabled buttons
    const previousButtonProps = canPreviousPage ? {} : {'aria-disabled': true};
    const nextButtonProps = canNextPage ? {} : {'aria-disabled': true};

    return (
        <div className="dfb-Table-pagination">
            <div className="dfb-Pagination dfb-Pagination--small" aria-label={ariaLabel}>
                <button
                    className="dfb-Button dfb-Button--icon dfb-Pagination-control dfb-Pagination-controlPrev"
                    onClick={() => previousPage()}
                    aria-label={previousAriaLabel}
                    {...previousButtonProps}
                >
                    <span className="dfb-Button-icon"><DfbDropdownLeftSymbol/></span>
                </button>

                <button
                    className="dfb-Button dfb-Button--icon dfb-Pagination-control dfb-Pagination-controlNext"
                    onClick={() => nextPage()}
                    aria-label={nextAriaLabel}
                    {...nextButtonProps}
                >
                    <span className="dfb-Button-icon"><DfbDropdownRightSymbol/></span>
                </button>

                <ul className="dfb-Pagination-pageList">
                    <li className={'dfb-Pagination-pageItem' + (pageIndex === 0 ? ' is-active' : '')}>
                        <button className="dfb-Pagination-pageLink"
                                onClick={() => gotoPage(0)}>
                            <span className="dfb-Pagination-pageLabel">1</span>
                        </button>
                    </li>
                    {
                        !!pageNumbers.length && pageNumbers[0] !== 2 &&
                        <li className="dfb-Pagination-pageItem">...</li>
                    }
                    {
                        pageNumbers.map(page =>
                            <li className={'dfb-Pagination-pageItem' + ((page - 1) === pageIndex ? ' is-active' : '')} key={page}>
                                <button className="dfb-Pagination-pageLink"
                                        onClick={() => gotoPage(page - 1)}>
                                    <span className="dfb-Pagination-pageLabel">{page}</span>
                                </button>
                            </li>
                        )
                    }
                    {
                        !!pageNumbers.length && pageNumbers[pageNumbers.length - 1] !== pageCount - 1 &&
                        <li className="dfb-Pagination-pageItem">...</li>
                    }
                    <li className={'dfb-Pagination-pageItem' + ((pageCount - 1) === pageIndex ? ' is-active' : '')}>
                        <button className="dfb-Pagination-pageLink"
                                onClick={() => gotoPage(pageCount - 1)}>
                            <span className="dfb-Pagination-pageLabel">{pageCount}</span>
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Pagination;
